import { http } from 'utils'
import { SET_ACTIVE_PLACEMENTS, SET_GRADUATE_PLACEMENTS, SET_AGENCIES, SET_GRADUATES, SET_PLACEMENT_COMPLETION, SET_PERFORMANCE_ASSESSMENTS } from 'vx/mutations'

const state = {
  placements: [],
  graduate_placements: [],
  agencies: [],
  graduates: [],
  placement_completion: [],
  performance_assessments: []
}

// Dashboard state getters.
const getters = {
  //
}

// Dashboard actions
const actions = {
  /**
   * Get a logged in user's (manager, coordinator) active placements.
   *
   * @return Promise
   */
  async getActivePlacements ({ commit }) {
    commit(SET_ACTIVE_PLACEMENTS, [])

    const response = await http.get('dashboard/active-placements')
    commit(SET_ACTIVE_PLACEMENTS, response.data.data)

    return response
  },

  /**
   * Get a logged in user's (manager, coordinator) graduate placements.
   *
   * @return Promise
   */
  async getGraduatePlacements ({ commit }) {
    commit(SET_GRADUATE_PLACEMENTS, [])

    const response = await http.get('dashboard/graduate-placements')
    commit(SET_GRADUATE_PLACEMENTS, response.data.data)

    return response
  },

  /**
   * Get an overview of agencies and the graduates that have placements there.
   *
   * @return Promise
   */
  async getAgenciesOverview ({ commit }) {
    commit(SET_AGENCIES, [])

    const response = await http.get('dashboard/agencies')
    commit(SET_AGENCIES, response.data.data)

    return response
  },

  /**
   * Get an a list of underperforming graduates.
   *
   * @return Promise
   */
  async getUnderperformingGraduates ({ commit }) {
    commit(SET_GRADUATES, [])

    const response = await http.get('dashboard/underperforming')
    commit(SET_GRADUATES, response.data.data)

    return response
  },

  /**
   * Get an a list of underperforming graduates.
   *
   * @return Promise
   */
  async getPlacementCompletion ({ commit }) {
    commit(SET_PLACEMENT_COMPLETION, [])

    const response = await http.get('dashboard/placement-completion')
    commit(SET_PLACEMENT_COMPLETION, response.data.data)

    return response
  },

  /**
   * Get a list of performance assessments.
   *
   * @return Promise
   */
  async getPerformanceAssessments ({ commit }) {
    commit(SET_PERFORMANCE_ASSESSMENTS, [])

    const response = await http.get('dashboard/performance-assessments')
    commit(SET_PERFORMANCE_ASSESSMENTS, response.data.data)

    return response
  }
}

// Dashboard state mutations.
const mutations = {
  [SET_ACTIVE_PLACEMENTS] (state, placements) {
    state.placements = placements
  },

  [SET_GRADUATE_PLACEMENTS] (state, placements) {
    state.graduate_placements = placements
  },

  [SET_AGENCIES] (state, agencies) {
    state.agencies = agencies
  },

  [SET_GRADUATES] (state, graduates) {
    state.graduates = graduates
  },

  [SET_PLACEMENT_COMPLETION] (state, placements) {
    state.placement_completion = placements
  },

  [SET_PERFORMANCE_ASSESSMENTS] (state, assessments) {
    state.performance_assessments = assessments
  }
}
// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
